import React from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import RecipientDetails from "../../RecipientDetails/RecipientDetails";
import styles from "./ReadyToSendModal.module.scss";
export default function ReadyToSendModal(props) {
  const {
    firstName,
    lastName,
    email,
    companyName,
    reviewers,
    dismissModal
  } = props;
  const effectiveReviewers = reviewers.filter(reviewer => reviewer.firstName && reviewer.lastName && reviewer.email);
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Ready to send?",
    "data-testid": "send-proposal-modal",
    width: "700px",
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      weight: "normal"
    }, "You're about to send this proposal to:"), /*#__PURE__*/React.createElement(RecipientDetails, {
      testid: "primary-recipient",
      firstName: firstName,
      lastName: lastName,
      email: email,
      companyName: companyName,
      badge: effectiveReviewers.length > 0 ? 'required' : undefined
    }), effectiveReviewers.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: styles.additionalRecipients
    }, /*#__PURE__*/React.createElement(Typography, {
      weight: "normal"
    }, "Additional recipients"), effectiveReviewers.map((reviewer, idx) => {
      return reviewer.firstName && reviewer.lastName && reviewer.email && /*#__PURE__*/React.createElement(RecipientDetails, {
        key: idx,
        testid: "additional-recipient-".concat(idx),
        firstName: reviewer.firstName,
        lastName: reviewer.lastName,
        email: reviewer.email,
        badge: reviewer.isSignatory ? 'required' : undefined
      });
    }))),
    textAlignCenter: false,
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false),
    primaryButtonLabel: "Send now",
    secondaryButtonLabel: "Back"
  });
}